import { useStore } from 'effector-react'
import { DrawerComponent } from '~/shared/ui/Drawer'
import {
  $isUploadDocumentDrawerOpen,
  closeUploadDocumentDrawer,
  createUpdateRequest,
  createUpdateRequestFx,
} from './model'
import { Title } from './styled'
import { Form } from './ui/Form'

export function UploadDocumentsDrawer() {
  const isUploadDocumentDrawerOpen = useStore($isUploadDocumentDrawerOpen)
  const createUpdateRequesPending = useStore(createUpdateRequestFx.pending)

  return (
    <DrawerComponent
      isShow={isUploadDocumentDrawerOpen}
      onCancel={closeUploadDocumentDrawer}
    >
      <Title>Для запуска проверок прикрепите необходимые документы</Title>
      <Form
        onSuccess={createUpdateRequest}
        isSubmitting={createUpdateRequesPending}
      />
    </DrawerComponent>
  )
}
